import { render, staticRenderFns } from "./CarouselTestimonials.vue?vue&type=template&id=0c2cbf87&scoped=true&"
import script from "./CarouselTestimonials.vue?vue&type=script&lang=js&"
export * from "./CarouselTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./CarouselTestimonials.vue?vue&type=style&index=0&id=0c2cbf87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cbf87",
  null
  
)

export default component.exports